import script from "./VoxelDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./VoxelDetail.vue?vue&type=script&setup=true&lang=js"

import "./VoxelDetail.vue?vue&type=style&index=0&id=4a9c4fbb&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a9c4fbb"]])

export default __exports__